// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3Xlpb","topBottomGutter":"Layout_topBottomGutter__1_FbK"};